<div class="media profile-media">
  <img
    class="b-r-10 img-30"
    src="assets/images/avtar/client_attention.png"
    alt=""
  />
  <div class="media-body">
    <span>{{ name }}</span>
    <p class="mb-0 font-roboto">
      {{ role }} <i class="middle fa fa-angle-down"></i>
    </p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li>
    <div *appShowWithPermission="PERMITTED_VIEWS.USER_ACCOUNT_VIEW">
      <a routerLink="{{ urlProfile }}">
        <shared-feather-icons [icon]="'user'"></shared-feather-icons>
        <span>{{ 'profile.account' | translate }}</span>
      </a>
    </div>
  </li>
  @if (
    userType === USER_TYPES.ADMIN ||
    userType === USER_TYPES.AGENT ||
    userType === USER_TYPES.COLLABORATOR_AGENT ||
    userType === USER_TYPES.COLLABORATOR_OPERATOR
  ) {
    <li
      class="d-block d-md-none"
      (click)="openMessages($event)"
      *appShowWithPermission="PERMITTED_VIEWS.MESSAGE_PLAYERS_WITH_AGENT"
    >
      <a>
        <div class="position-relative d-inline-block">
          <shared-feather-icons [icon]="'mail'"></shared-feather-icons>
          @if (messageCount > 0) {
            <span
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger w-100"
              style="font-size: 0.6rem; padding: 0.2rem 0.4rem"
            >
              {{ messageCount > 99 ? '99+' : messageCount }}
            </span>
          }
        </div>
        <span>
          {{ 'profile.messages' | translate }}
        </span>
      </a>
    </li>
  }

  <li class="d-block d-md-none" (click)="languageToggle()">
    <a>
      <shared-feather-icons [icon]="'globe'"></shared-feather-icons>
      <span>
        {{ 'profile.language' | translate }}:{{ currentLang | uppercase }}
      </span>
    </a>
  </li>

  <li class="d-block d-md-none" (click)="layoutToggle()">
    <a>
      @if (isDark) {
        <shared-feather-icons [icon]="'moon'"></shared-feather-icons>
      } @else {
        <shared-feather-icons [icon]="'sun'"></shared-feather-icons>
      }
      <span>
        {{
          isDark
            ? ('profile.lightMode' | translate)
            : ('profile.darkMode' | translate)
        }}
      </span>
    </a>
  </li>
  <li (click)="logoutFunc()">
    <shared-feather-icons [icon]="'log-in'"></shared-feather-icons>
    <span>{{ 'profile.logOut' | translate }}</span>
  </li>
</ul>
